// import { Alert } from "components/Alert/Alert";
// import { useLangContext } from "components/Lang/Lang";
// import { Loading } from "components/Loading/Loading";
// import {  Geometry, GeometryTypes } from "components/ThreeItems/Geometry/Geometry";
// import { SceneItemsType } from "components/ThreeItems/Scene";
import { Geometry } from "components/ThreeItems/Geometry/Geometry";
import { useLangContext } from "context/Lang";
import { ToastMessage } from "primereact/toast";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { routes } from "routes";
import { AsyncProcess } from "services/AsyncProcess";
import { setToast } from "storeRedux/slices/toast";
import * as THREE from "three"
import { rgbToHex } from "utils/color/rgbToHex";
import { ReplaceWords } from "utils/ReplaceWords";
// import { ColorsType, ObjectType } from "types";
// import { CategoriObjectProps,  MapItemProps, MaterialTypeProps } from "types/three";
// import { rgbToHex } from "utils/rgbToHex";
import { StringJSONPRS } from "utils/StringJsonPRS";






type meshFunProcess = ({ ...e }: { mesh: THREE.Object3D, copy?: boolean, effect?: () => void }) => void




export interface EditorContextProps {

    addMesh?: ({ mesh }: { mesh?: MeshProps }) => void,
    // cards?:CategoriObjectProps[]|null,
    // setCards?:React.Dispatch<React.SetStateAction<CategoriObjectProps[] | null>>,
    // category?:CategoriObjectProps[]|null,
    // setCategory?:React.Dispatch<React.SetStateAction<CategoriObjectProps[] | null>>,
    // setMeshes?:React.Dispatch<React.SetStateAction<MapItemProps[] >>, 
    meshes?: MeshProps[],
    setDeletedMeshes?: React.Dispatch<React.SetStateAction<THREE.Object3D[]>>,
    deletedMeshes?: THREE.Object3D[],

    handleSave?: meshFunProcess,
    handleUpdate?: meshFunProcess,
    handleDelete?: meshFunProcess,

    selectMesh?: THREE.Object3D | null
    setSelectMesh?: React.Dispatch<React.SetStateAction<THREE.Object3D | null>>

    sceneItemsRef?: React.RefObject<SceneItemsProps | undefined>
    handleLoadScene?: (e: SceneItemsProps) => void
    // handleLoadScene?:({...e}:SceneItemsType)=>void


    // materials?:MaterialTypeProps[]|null
    // setMaterials?:React.Dispatch<React.SetStateAction<MaterialTypeProps[]|null>>

    // selectMaterial?:MaterialTypeProps|null
    // setSelectMaterial?:React.Dispatch<React.SetStateAction<MaterialTypeProps|null>>


    getMeshes?: () => void

}


const EditorContext = createContext<EditorContextProps>({});

const geometryCache = new Map<string, THREE.BufferGeometry>();
const materialCache = new Map<string, THREE.Material>();


type EditorProviderProps = {
    onDataLoad?: (e?: any) => void,
    children: any,
    editorId?: number
}

export const EditorProvider = ({ ...props }: EditorProviderProps) => {



    // const [alert,setAlert]=useState<{color?:ColorsType,message:string}|null>(null);


    const sceneItemsRef = useRef<SceneItemsProps | undefined>(undefined);

    const { gW } = useLangContext();

    const [selectMesh, setSelectMesh] = useState<THREE.Object3D | null>(null);

    // const [cards,setCards]=useState<CategoriObjectProps[]|null>(null);
    // const [category,setCategory]=useState<CategoriObjectProps[]|null>(null);

    const [meshes, setMeshes] = useState<MeshProps[]>([]);
    const [deletedMeshes, setDeletedMeshes] = useState<THREE.Object3D[]>([]);
    const [searchParams] = useSearchParams();

    const editorId = props?.editorId || searchParams.get("editorId");

    const [block, setBlock] = useState<boolean>(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const [materials,setMaterials]=useState<MaterialTypeProps[]|null>(null);
    // const [selectMaterial,setSelectMaterial]=useState<MaterialTypeProps|null>(null);

    useEffect(() => {
        return () => {
            geometryCache.forEach(g => g.dispose());
            materialCache.forEach(m => m.dispose());
            geometryCache.clear();
            materialCache.clear();
        };
    }, [editorId]);


    
    // const addMesh = ({ mesh, isSelect = true }: { mesh?: MeshProps, isSelect?: boolean }): void => {

    //     if (sceneItemsRef.current) {
    //         const tempMesh = new THREE.Mesh();

    //         const a = mesh?.type;
    //         const prs = mesh?.prs ? StringJSONPRS({ data: mesh?.prs + "" }) as ObjectType<any> : {}

    //         const [px, py, pz] = prs.position || [0, 0, 0];
    //         tempMesh.position.set(px, py, pz);

    //         const [rx, ry, rz] = prs.rotation || [0, 0, 0];
    //         tempMesh.rotation.set(rx, ry, rz);

    //         const [sx, sy, sz] = prs.scale || [1, 1, 1];
    //         tempMesh.scale.set(sx, sy, sz);


    //         if (tempMesh.userData) {
    //             tempMesh.userData.id = mesh?.id;
    //             tempMesh.userData.materialId = mesh?.material?.id;
    //             tempMesh.userData.image = mesh?.imageUrl;
    //         }





    //         const tempGeometry = Geometry({
    //             type: a,
    //             radialSegments: mesh?.radialSegments,
    //             parameters: mesh?.parameters,
    //             material: {
    //                 color: mesh?.color,
    //                 imageUrl: mesh?.material?.imageUrl as string || null,
    //                 opacity: Number(mesh?.opacity || 1)
    //             }
    //         });



    //         tempMesh.name = mesh?.name || "";

    //         tempMesh.userData.type = a;
    //         tempMesh.userData.imageUrl = mesh?.material?.imageUrl;
    //         tempMesh.userData.materialId = mesh?.material?.id;


    //         tempMesh.geometry = tempGeometry.mesh.geometry;
    //         tempMesh.material = tempGeometry.mesh.material;

    //         // tempMesh.add(tempGeometry.mesh);

    //         tempMesh.updateMatrix();

    //         if (isSelect) {
    //             setSelectMesh(tempMesh);
    //         } else {
    //             setSelectMesh(null);
    //         }

    //         sceneItemsRef?.current?.scene_group?.add?.(tempMesh);
    //     }


    // }

    const addMesh = ({ mesh, isSelect = true }: { mesh?: MeshProps, isSelect?: boolean }): void => {
        if (!sceneItemsRef.current?.scene_group) return;

        // توليد مفاتيح الكاش الفريدة بناءً على خصائص العنصر
        const geoKey = `${mesh?.type}_${mesh?.radialSegments || 'default'}_${JSON.stringify(mesh?.parameters || {})}`;
        const matKey = `${mesh?.color || '#ffffff'}_${mesh?.material?.imageUrl || 'none'}_${mesh?.opacity || 1}`;
        let finalObject: THREE.Object3D;

        // 2. استخدام الماتيريال والجيومتري من الكاش أو إنشائهم إذا لم يتواجدوا
        let sharedGeometry = geometryCache.get(geoKey);
        let sharedMaterial = materialCache.get(matKey);

        const temp = Geometry({
            type: mesh?.type,
            radialSegments: mesh?.radialSegments,
            parameters: mesh?.parameters,
            material: { color: mesh?.color||"#eeeeee", imageUrl: mesh?.material?.imageUrl as string   || null, opacity: Number(mesh?.opacity || 1) }
        });

        if (!sharedGeometry) {
            sharedGeometry = temp.mesh.geometry;
            geometryCache.set(geoKey, sharedGeometry);
        }

        if (!sharedMaterial) {
           
            sharedMaterial = temp.mesh.material as THREE.Material;
            materialCache.set(matKey, sharedMaterial);
        }


        // 3. تطبيق نظام الـ LOD (Level of Detail) للأشكال الكروية أو المعقدة لزيادة النعومة وسلاسة الشاشة
        // if (mesh?.type === "sphere" || mesh?.type === "cylinder" || mesh?.radialSegments) {
        //     const lod = new THREE.LOD();

        //     // المستوى العالي (قريب من الكاميرا) - Smooth High Poly
        //     const highMesh = new THREE.Mesh(sharedGeometry, sharedMaterial);
        //     lod.addLevel(highMesh, 0); 

        //     // المستوى المتوسط (مسافة متوسطة) - Mid Poly
        //     const midSegments = Math.max(4, Math.floor((mesh?.radialSegments || 32) / 2));
        //     const midGeo = new THREE.SphereGeometry(mesh?.parameters?.radius || 5, midSegments, midSegments);
        //     const midMesh = new THREE.Mesh(midGeo, sharedMaterial);
        //     lod.addLevel(midMesh, 40);

        //     // المستوى المنخفض (بعيد جداً) - Low Poly لتوفير كارت الشاشة
        //     const lowGeo = new THREE.BoxGeometry(mesh?.parameters?.radius || 3, mesh?.parameters?.radius || 1, mesh?.parameters?.radius || 1);
        //     const lowMesh = new THREE.Mesh(lowGeo, sharedMaterial);
        //     lod.addLevel(lowMesh, 100);


     

        //     finalObject = lod;
        // } else {
            // للأشكال العادية مثل الـ Box لا نحتاج LOD معقد، Mesh عادي يكفي
        finalObject = new THREE.Mesh(sharedGeometry, sharedMaterial);
        finalObject.userData={...temp.mesh.userData}
        // }

        // إعداد المصفوفات والتحويلات
        const prs = mesh?.prs ? StringJSONPRS({ data: mesh?.prs + "" }) as any : {};
        const [px, py, pz] = prs.position || [0, 0, 0];
        finalObject.position.set(px, py, pz);

        const [rx, ry, rz] = prs.rotation || [0, 0, 0];
        finalObject.rotation.set(rx, ry, rz);

        const [sx, sy, sz] = prs.scale || [1, 1, 1];
        finalObject.scale.set(sx, sy, sz);

        finalObject.name = mesh?.name || "Unnamed Mesh";
        
        finalObject.userData = {
            ...finalObject.userData,
            id: mesh?.id,
            type: mesh?.type,
            materialId: mesh?.material?.id,
            imageUrl: mesh?.material?.imageUrl,
            isLOD: finalObject instanceof THREE.LOD,
        };

        finalObject.updateMatrix();

        if (isSelect) {
            setSelectMesh(finalObject);
        } else {
            setSelectMesh(null);
        }

        sceneItemsRef.current.scene_group.add(finalObject);
    };


    const loadMeshes = (meshes?: MeshProps[]) => {
        if (sceneItemsRef?.current?.scene_group && meshes) {
            sceneItemsRef.current.scene_group.children = [];
            meshes?.forEach(mesh => {
                addMesh?.({ mesh, isSelect: false });
            })

            props.onDataLoad?.();
        }
    }


    // useEffect(()=>{
    //     setMeshes([]);
    //     return ()=>{
    //         setMeshes([]);
    //     }
    // },[pathname]);


    const handleLoadScene = (e: SceneItemsProps): void => {
        sceneItemsRef.current = e;
        loadMeshes(meshes);

    }



    // const getMaterials=()=>{
    //     setBlock(true);   
    //     AsyncProcess({
    //         type:"get",
    //         url:routes.api.material,
    //         setError:(err)=>{
    //             setAlert({message:gW(err?.error||"happen-error"),color:"red"})
    //             setBlock(false);
    //         },
    //         effectProcess:[(res)=>{
    //             setMaterials(res.map((r:any)=>({...r,image: r?.image?(process.env.REACT_APP_API_URL||"")+r?.image:""})));    
    //             setBlock(false);
    //         }]
    //     });



    // }


    const getMeshes = () => {


        if (editorId) {

            if (sceneItemsRef.current?.scene_group) {
                setSelectMesh(null);
                sceneItemsRef.current.scene_group.children = []

            }

            setBlock(true);

            AsyncProcess({
                type: "get",
                url: ReplaceWords(routes.api.meshesByThreeItemEditor, { id: editorId }),

                setError: (e) => {
                    dispatch(setToast({ severity: "error", detail: gW("happen-error") } as ToastMessage))
                    setBlock(false);
                },
                effectProcess: [(res) => {

                    if (res?.success === false) {
                        dispatch(setToast({ severity: "error", detail: gW(res?.message||"happen-error") } as ToastMessage))


                    } else {
                        const m = res?.data;
                        setMeshes?.(m);
                        loadMeshes(m)

                    }
                    setBlock(false)
                }]
            })
        }
    }





    useEffect(() => {
        if (editorId) {
            getMeshes();
        }
    }, [editorId])


    const doSave = (mesh: THREE.Object3D, effect?: () => void) => {



        const data = {
            name: mesh.name,
            type: mesh?.userData?.type,
            prs: StringJSONPRS({ data: mesh }),
            color: rgbToHex(((mesh as THREE.Mesh).material as THREE.MeshPhysicalMaterial).color),
            opacity: ((mesh as THREE.Mesh).material as THREE.MeshPhysicalMaterial).opacity,
            parameters: JSON.stringify(((mesh as THREE.Mesh).geometry as any)?.parameters || {}),
            materialId: mesh.userData?.materialId,
            threeItemEditorId: editorId
            // objectid: objectid
        }

        setBlock(true);

        AsyncProcess({
            type: "post",
            data: data,
            // headers: { "Content-Type": "multipart/form-data" },
            url: routes.api.meshes,
            setError: (e) => {
                dispatch(setToast({ severity: "error", detail: gW("happen-error") } as ToastMessage))
                setBlock(false);
            },
            effectProcess: [(res) => {

                if (res?.success === false) {
                    dispatch(setToast({ severity: "error", detail: gW(res?.message || "happen-error") } as ToastMessage))
                } else {



                    if (res?.data?.id) {
                        setSelectMesh(null);
                        mesh.userData = { ...mesh.userData, id: res?.data?.id }

                        effect?.();

                    } else {
                        // getMeshes();
                    }
                }

                setBlock(false)
            }]
        });
    }

    const handleSave: meshFunProcess = ({ mesh, copy, effect }) => {



      

        if (copy && mesh.userData?.id) {
            handleUpdate({
                mesh, effect: () => {
                    effect?.();
                    if (copy) {
                        setTimeout(() => {
                            delete mesh.userData.id;

                            mesh.uuid = THREE.MathUtils.generateUUID();

                            if ((mesh as THREE.Mesh).material) {
                                const currentMaterial = (mesh as THREE.Mesh).material as THREE.Material;
                                (mesh as THREE.Mesh).material = currentMaterial.clone();
                            }

                            sceneItemsRef.current?.scene_group?.add(mesh);
                            setSelectMesh(mesh);
                        }, 10);
                    }
                }
            })
        } else {
            doSave(mesh, copy ? () => {
                setTimeout(() => {
                    delete mesh.userData.id;
                    mesh.uuid = THREE.MathUtils.generateUUID();
                    if ((mesh as THREE.Mesh).material) {
                        const currentMaterial = (mesh as THREE.Mesh).material as THREE.Material;
                        (mesh as THREE.Mesh).material = currentMaterial.clone();
                    }

                    sceneItemsRef.current?.scene_group?.add(mesh);
                    setSelectMesh(mesh);
                }, 10);
            } : undefined);
        }









    }


    const handleUpdate: meshFunProcess = ({ mesh, effect }) => {


        
        const data = {
            name: mesh.name,
            type: mesh?.userData?.type,
            prs: StringJSONPRS({ data: mesh }),
            color: rgbToHex(((mesh as THREE.Mesh).material as THREE.MeshPhysicalMaterial).color),
            opacity: ((mesh as THREE.Mesh).material as THREE.MeshPhysicalMaterial).opacity,
            parameters: JSON.stringify(((mesh as THREE.Mesh).geometry as any)?.parameters || {}),
            materialId: mesh.userData?.materialId,
            threeItemEditorId: editorId
        }

        AsyncProcess({
            type: "post",
           
            data: data,
            url: routes.api.meshes + "/" + mesh.userData.id,
            setError: (e) => {
                dispatch(setToast({ severity: "error", detail: gW("happen-error") } as ToastMessage))

                setBlock(false);
            },
            effectProcess: [(res) => {

                if (res?.success === false) {
                    dispatch(setToast({ severity: "error", detail: gW(res?.message || "happen-error") } as ToastMessage))
                } else {
                    effect?.();
                    if (res?.data?.id) {
                        setSelectMesh(null);
                        effect?.();
                        // mesh.userData = { ...mesh.userData, id: res?.data?.id }
                    } else {
                        // getMeshes();
                    }
                }
                setSelectMesh(null);
                setBlock(false)
            }]
        });

    }




    const handleDelete: meshFunProcess = ({ mesh, effect }) => {
        if (mesh?.userData?.id) {
            setBlock(true);
            AsyncProcess({
                type: "post",
                url: routes.api.meshes + "/delete/" + mesh?.userData?.id,
                setError: (e) => {

                    dispatch(setToast({ severity: "error", detail: "error" } as ToastMessage))
                    // setAlert({ color: "red", message: gW(e?.error, e?.words) })
                    setBlock(false);
                },
                effectProcess: [(res) => {

                    if (res?.success === false) {
                        dispatch(setToast({ severity: "error", detail: gW(res?.message || "happen-error") } as ToastMessage))
                    } else {
                        effect?.();
                        setSelectMesh(null);
                        sceneItemsRef.current?.scene_group?.remove?.(mesh);
                    }

                    setBlock(false);

                }]
            });
        } else {
            sceneItemsRef.current?.scene_group?.remove?.(mesh);
            setSelectMesh(null);
            effect?.();
        }


    }



    const values: EditorContextProps = {
        // cards,setCards,
        addMesh,
        // setMeshes,
        meshes,

        handleSave,
        handleUpdate,
        handleDelete,

        // category,setCategory,
        // deletedMeshes,setDeletedMeshes,
        selectMesh,
        setSelectMesh,
        // sceneItemsRef,
        handleLoadScene,
        getMeshes,

        // materials,
        // setMaterials
    }

    return (<EditorContext.Provider value={values}>
        {/* {alert&&<Alert color={alert.color} open={alert!==null} onClose={()=>setAlert(null)}  messages={[<p key={1} > {alert.message} </p>]} />} */}
        {props.children}
        {/* {block&&<Loading/>} */}
    </EditorContext.Provider>)
}



export const useEditorContext = () => useContext<EditorContextProps>(EditorContext);